import React, { useState } from "react";
import { IoMdRefresh } from "react-icons/io";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import "../../assets/css/ServicesFilter.scss";
import ListItemText from "@mui/material/ListItemText";
import { HiMiniXMark } from "react-icons/hi2";
import { Checkbox } from "@mui/material";
import useTitanApp from "../../hooks/useTitanApp";
import { setCurrentPharmacyServices } from "../../dispatchers/pharmacyServiceDispatchers";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { motion } from "framer-motion";

function RefreshBoard({ refreshBoardData }) {
  const handleButtonClick = () => {
    refreshBoardData();
  };

  return (
    <div className="filter_button_container">
      <button onClick={handleButtonClick} className="kanban-control-btn">
        <IoMdRefresh className="icons-color" size={14} />
        <p>Refresh</p>
      </button>
    </div>
  );
}

export default RefreshBoard;
